export default "__VITE_ASSET__DcxSSlES__"